import React from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { isEmpty, lowerCase } from "lodash";
import moment from "moment";

import StatsPanel from "../chart-container";
import DatePicker from "../../../base/date-picker";
import DashboardWidgetService from "../../../../services/dashboard-widgets";

import "./style.css";

const SubscriptionChargeAttemptsTable = ({ chargeAttempts }) => {
  return (
    <TableContainer className="subscription-charge-attempt-table">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">created at</TableCell>
            <TableCell align="center">member id</TableCell>
            <TableCell align="center">payment gateway</TableCell>
            <TableCell align="center">status</TableCell>
            <TableCell align="center">remarks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(chargeAttempts) &&
            chargeAttempts.map((chargeAttempt) => (
              <TableRow>
                <TableCell align="center">
                  {moment(chargeAttempt.createdAt).format(
                    "YYYY-MM-DD hh:mm:ss"
                  )}
                </TableCell>
                <TableCell align="center">{chargeAttempt.memberId}</TableCell>
                <TableCell
                  align="center"
                  className={lowerCase(chargeAttempt.ipgType)}
                >
                  {chargeAttempt.ipgType}
                </TableCell>
                <TableCell
                  align="center"
                  className={lowerCase(chargeAttempt.status)}
                >
                  {chargeAttempt.status}
                </TableCell>
                <TableCell>{chargeAttempt.response}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const DailySubscriptionChargeAttempts = () => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [chargeAttempts, setChargeAttempts] = React.useState([]);
  const [error, setError] = React.useState("");
  const [submitCount, setSubmitCount] = React.useState(0);

  const btnDisabled = React.useMemo(() => {
    return (
      !startDate || !endDate || moment(startDate).isAfter(endDate) || loading
    );
  }, [endDate, loading, startDate]);

  const onClickShowResults = React.useCallback(() => {
    setLoading(true);
    setChargeAttempts([]);
    setError("");
    DashboardWidgetService.getSubscriptionChargeAttempts({
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(endDate).format("YYYY-MM-DD"),
    })
      .then((response) => {
        if (!response.success) {
          setError(response.body.message ?? "Error Occurred");
          return;
        }
        setChargeAttempts(response.body);
      })
      .finally(() => {
        setTimeout(() => {
          setSubmitCount(submitCount + 1);
          setLoading(false);
        }, 1000);
      });
  }, [endDate, startDate, submitCount]);

  return (
    <StatsPanel
      title="daily subscription charge attempts"
      rootCSSClass="daily-subscription-charge-attempts"
    >
      <Grid container direction="column" className="gap-y-16">
        <Grid container direction="row" className="gap-x-16">
          <DatePicker
            label="From"
            selectedDate={startDate}
            onChangeDate={(date) => setStartDate(date)}
          />
          <DatePicker
            label="To"
            selectedDate={endDate}
            onChangeDate={(date) => setEndDate(date)}
          />
          <Button
            className="show-results-btn"
            disabled={btnDisabled}
            startIcon={loading && <CircularProgress size={15} />}
            onClick={onClickShowResults}
          >
            Show Results
          </Button>
        </Grid>
        {!isEmpty(error) && (
          <Typography variant="body2" className="widget-error">
            {error}&nbsp;&nbsp; &nbsp;
            <span className="try-agian" onClick={onClickShowResults}>
              try again!
            </span>
          </Typography>
        )}
        {!isEmpty(chargeAttempts) && (
          <SubscriptionChargeAttemptsTable chargeAttempts={chargeAttempts} />
        )}
        {submitCount > 0 && isEmpty(chargeAttempts) && isEmpty(error) && (
          <Typography variant="body1">No Results Found</Typography>
        )}
      </Grid>
    </StatsPanel>
  );
};

export default DailySubscriptionChargeAttempts;
